import {
  LINE_WIDTH_DIVIDER,
  MIN_LINE_WIDTH,
  STROKE_COLOR
} from '@/features/report-problem/lib/annotationStyle';
import {
  denormalizeRect,
  INormalizedRect
} from '@/features/report-problem/lib/rects';

/**
 * Запечь рамки-выделения в скриншот и получить файл для отправки.
 * @param screenshot - canvas со снимком экрана
 * @param rects - рамки в долях от размеров скриншота
 */
export const bakeAnnotations = async (
  screenshot: HTMLCanvasElement,
  rects: INormalizedRect[]
): Promise<File | null> => {
  const canvas = document.createElement('canvas');

  canvas.width = screenshot.width;
  canvas.height = screenshot.height;

  const context = canvas.getContext('2d');

  if (!context) return null;

  context.drawImage(screenshot, 0, 0);

  context.strokeStyle = STROKE_COLOR;
  context.lineWidth = Math.max(
    MIN_LINE_WIDTH,
    canvas.width / LINE_WIDTH_DIVIDER
  );

  rects.forEach(rect => {
    const { height, width, x, y } = denormalizeRect(
      rect,
      canvas.width,
      canvas.height
    );

    context.strokeRect(x, y, width, height);
  });

  const blob = await new Promise<Blob | null>(resolve => {
    canvas.toBlob(resolve, 'image/png');
  });

  if (!blob) return null;

  return new File([blob], 'screenshot.png', { type: 'image/png' });
};
